import { useEffect, useRef, useState } from 'react';
import { useInView } from 'framer-motion';
import Reveal from './Reveal';
import { STATS } from '@/config/site';

function Counter({ value, prefix = '', suffix = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-15% 0px' });
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!inView) return undefined;
    const start = performance.now();
    const duration = 1400;
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / duration, 1);
      setN(Math.round(value * (1 - Math.pow(1 - p, 4))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [inView, value]);
  return (
    <span ref={ref}>
      {prefix}
      {n}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section id="resultados" data-testid="stats-section" className="border-t border-white/5 bg-noir px-5 py-20 sm:px-10 sm:py-28">
      <div className="mx-auto max-w-6xl">
        <Reveal>
          <p className="mb-12 flex items-center gap-3 text-[10px] uppercase tracking-[0.45em] text-gold">
            <span className="h-px w-8 bg-gold/60" /> Resultados
          </p>
        </Reveal>
        <div className="grid grid-cols-2 gap-px bg-white/5 lg:grid-cols-4" data-testid="stats-grid">
          {STATS.map((s, i) => (
            <div key={s.label} data-testid={`stat-${i + 1}`} className="bg-noir px-5 py-10 sm:px-8 sm:py-14">
              <Reveal delay={i * 0.06}>
                <p className="font-display text-4xl text-cream sm:text-6xl">
                  {typeof s.value === 'number' ? <Counter value={s.value} prefix={s.prefix || ''} suffix={s.suffix || ''} /> : s.value}
                </p>
                <p className="mt-3 text-[9px] uppercase tracking-[0.3em] text-cream/50 sm:text-[10px]">{s.label}</p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
